import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { snackbarTypes } from '@/constants/alertTypes';
import alertsUtil from '@/util/alertsUtil';
import useSelectDefaultProjectMutation from '@API/project/useSelectDefaultProjectMutation';
import { AUTO_GENERATED_OPTION_ID } from '@shared/constants';
import useChangeCurrentView from './useChangeCurrentView';

type SetDefaultArgs = {
  viewName?: string;
  viewId?: string;
  showMessage?: boolean;
};

const useSetDefaultView = () => {
  const dispatch = useDispatch();
  const {
    mutate: selectDefaultProject,
    isLoading: isSelectingDefaultProject
  } = useSelectDefaultProjectMutation();
  const { changeCurrentView } = useChangeCurrentView();

  return useCallback(
    ({ viewId, viewName, showMessage = false }: SetDefaultArgs) => {
      if (isSelectingDefaultProject) return;

      selectDefaultProject(
        { viewId },
        {
          onSuccess() {
            if (showMessage) {
              dispatch(
                alertsUtil.openSnackbarDialog(
                  snackbarTypes.SUCCESS_API_RESPONSE,
                  `The default view for all users in this project was changed to "${viewName}".`
                )
              );
            }
          }
        }
      );

      changeCurrentView(viewId || AUTO_GENERATED_OPTION_ID);
    },
    [
      changeCurrentView,
      dispatch,
      isSelectingDefaultProject,
      selectDefaultProject
    ]
  );
};

export default useSetDefaultView;
